export class Emitter<T> {
    private listeners = new Set<(v: T) => void>();

    subscribe(fn: (v: T) => void): () => void {
        this.listeners.add(fn);
        return () => this.listeners.delete(fn);
    }

    emit(value: T): void {
        for (const fn of [...this.listeners]) {
            try { 
                fn(value); 
            } 
            catch (e) { 
                console.error(e); 
            }
        }
    }

    clear(): void {
        this.listeners.clear();
    }
}